<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>{{ data.sysText.spreadLeaveHours_title }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="dialog-section">
      <mat-icon class="field-icon">today</mat-icon>
      <p class="grey1">{{ data.sysText.dateSection }}</p>
      <!-- buttons so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
        [matTooltip]="data.sysText.spreadLeaveHours_info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="before">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>
    <app-date-field
      class="half-column"
      [group]="form"
      [control]="form.controls.startDate"
      [label]="data.sysText.startDate">
    </app-date-field>
    <app-date-field
      class="half-column"
      [group]="form"
      [control]="form.controls.endDate"
      [label]="data.sysText.endDate">
    </app-date-field>
    <div class="dialog-section">
      <mat-icon class="field-icon">schedule</mat-icon>
      <p class="grey1">{{ data.sysText.daysSection }}</p>
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
        [matTooltip]="data.sysText.daysSection_info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="before">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>
    <div class="toggle-section">
      <div class="toggle-container">
        <app-slide-toggle
          [control]="form.controls.useWorkSchedule"
          [label]="data.sysText.useWorkSchedule"
          [capitalizeLabel]="false">
        </app-slide-toggle>
      </div>
    </div>
    <app-input-field
      [label]="data.sysText.averageHoursPerWeek"
      [removeLabelCasePipe]="true"
      [control]="leaveDaysGroup.controls.averageHoursPerWeek"
      [inputType]="'number'"
      [retainDefaultDisabled]="true">
    </app-input-field>
    <div class="checkbox-section">
      <div class="checkbox">
        <p class="body2">{{this.data.sysText.sunday}}</p>
        <mat-checkbox
          [formControl]="leaveDaysGroup.controls.sundayLeave"
          [aria-label]="data.sysText.sunday">
        </mat-checkbox>
      </div>
      <div class="checkbox">
        <p class="body2">{{this.data.sysText.monday}}</p>
        <mat-checkbox
          [formControl]="leaveDaysGroup.controls.mondayLeave"
          [aria-label]="data.sysText.monday">
        </mat-checkbox>
      </div>
      <div class="checkbox">
        <p class="body2">{{this.data.sysText.tuesday}}</p>
        <mat-checkbox
          [formControl]="leaveDaysGroup.controls.tuesdayLeave"
          [aria-label]="data.sysText.tuesday">
        </mat-checkbox>
      </div>
      <div class="checkbox">
        <p class="body2">{{this.data.sysText.wednesday}}</p>
        <mat-checkbox
          [formControl]="leaveDaysGroup.controls.wednesdayLeave"
          [aria-label]="data.sysText.wednesday">
        </mat-checkbox>
      </div>
      <div class="checkbox">
        <p class="body2">{{this.data.sysText.thursday}}</p>
        <mat-checkbox
          [formControl]="leaveDaysGroup.controls.thursdayLeave"
          [aria-label]="data.sysText.thursday">
        </mat-checkbox>
      </div>
      <div class="checkbox">
        <p class="body2">{{this.data.sysText.friday}}</p>
        <mat-checkbox
          [formControl]="leaveDaysGroup.controls.fridayLeave"
          [aria-label]="data.sysText.friday">
        </mat-checkbox>
      </div>
      <div class="checkbox">
        <p class="body2">{{this.data.sysText.saturday}}</p>
        <mat-checkbox
          [formControl]="leaveDaysGroup.controls.saturdayLeave"
          [aria-label]="data.sysText.saturday">
        </mat-checkbox>
      </div>
    </div>
    <div class="dialog-section">
      <mat-icon class="field-icon">tune</mat-icon>
      <p class="grey1">{{data.sysText.spreadHoursOptions}}</p>
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
        [matTooltip]="data.sysText.additionalOptions_info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="before">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>
    <div class="toggle-section">
      <div class="toggle-container">
        <app-slide-toggle
          [control]="form.controls.removeExistingHours"
          [label]="data.sysText.removeExistingHours"
          [capitalizeLabel]="false">
        </app-slide-toggle>
      </div>
      <div class="toggle-container">
        <app-slide-toggle
          [control]="form.controls.removeOnlySpreadPeriod"
          [label]="data.sysText.removeOnlySpreadPeriod"
          [capitalizeLabel]="false">
        </app-slide-toggle>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{ data.sysText.submit }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

